export class OfferSwitcher {
    constructor(element) {
        this.wrapper = $(element);
        this.productId = this.wrapper.data('product');

        let data = (typeof window.OFFERS !== 'undefined') ? window.OFFERS : {};
        data = (data.hasOwnProperty(this.productId)) ? data[this.productId] : {};

        this.offers = (data.hasOwnProperty('offers')) ? data.offers : [];

        this.selected = {offer: null, size: null};

        this.process();
    }
    process() {
        this.setElementsClasses();
        this.bindEvents();
        this.bindHandlers();
        this.initSelected();

        this.collectElements();
        this.initButtons();
    }
    setElementsClasses() {
        this.SIZE_CLASS = 'js-product_offer-size';
        this.SIZE_WRAPPER_CLASS = 'js-product_offer-size-wrapper';
        this.SIZE_LABEL_CLASS = 'js-product_offer-size_label';

        this.PRICE_CLASS = 'js-new-price';

        this.ARTICLE_CLASS = 'js-product_article';

        this.ADD_TO_BASKET_BUTTON_CLASS = 'js-ab-add_to_basket';
        this.FAST_BUY_BUTTON_CLASS = 'js-fast_buy';

        this.OFFER_ID_CLASS = 'js-product_offer-id';
        this.OFFER_REMAINS_CLASS = 'js-product_remains'

        this.ACTIVE_CLASS = 'active';
        this.ENABLED_CLASS = 'have';
        this.LABEL_CLASS = 'last';

        this.SIZE_LABEL_TEMPLATE = '<span class="' + this.LABEL_CLASS + ' ' + this.SIZE_LABEL_CLASS + '">#label#</span>';
    }
    bindEvents() {
        this.wrapper.find('.' + this.SIZE_CLASS)
            .off('click')
            .on('click', (event) => this.switchSizesAndColors.call(this, event));
    }
    bindHandlers() {
        this.handlers = {
            size: {
                active: (item, status = false) => {
                    item.closest('.' + this.SIZE_WRAPPER_CLASS).toggleClass(this.ACTIVE_CLASS, status);
                },
                enabled: (item, status = false) => {
                    item.closest('.' + this.SIZE_WRAPPER_CLASS).toggleClass(this.ENABLED_CLASS, status);
                },
                label: (item, label = null) => {
                    let
                        parent = item.closest('.' + this.SIZE_WRAPPER_CLASS),
                        existsLast = parent.find('.' + this.SIZE_LABEL_CLASS);

                    if (label === null) {
                        if (existsLast && existsLast.length > 0) {
                            existsLast.remove();
                        }

                        return;
                    }

                    if (existsLast && existsLast.length > 0) {
                        existsLast.text(label);
                    } else {
                        item.append(this.SIZE_LABEL_TEMPLATE.replace('#label#', label))
                    }
                },
            },
        };

        this.checkers = {
            size: {
                enabled: (item) => {
                    return item.closest('.' + this.SIZE_WRAPPER_CLASS).hasClass(this.ENABLED_CLASS);
                },
            },
        };
    }
    collectElements() {
        let
            $this = this;

        this.offers.forEach((offer) => {
            offer.size.element = this.wrapper.find('.' + $this.SIZE_CLASS + '[data-value="' + offer.size.value + '"]');
        });
    }
    get size() {
        return (this.selected.size) ? this.selected.size.data('value') : null;
    }
    switchSizesAndColors(event) {
        event.preventDefault();

        let item = $(event.currentTarget),
            type = 'size';

        if (!this.checkers[type].enabled(item)) {
            return;
        }

        this.selected[type] = item;

        this.setOffer();
        this.setCheckedId();
        this.setArticle();

        this.switchAllSizeElements();
        this.initButtons();
    }
    switchAllSizeElements() {
        let $this = this;

        this.wrapper.find('.' + this.SIZE_CLASS).each((index, size) => {
            size = $(size);

            $this.handlers.size.active(
                size,
                !!($this.size && size.data('value') === $this.size)
            );
        });
    }
    setOffer() {
        let size = this.selected.size || null;

        if (!size) {
            this.selected.offer = null;

            return null;
        }

        this.selected.offer = this.findOffer(size.data('value'));

        // TODO: fix it if we want to have different prices for offers
        // if (size.data('price')) {
        //     this.wrapper.find('.' + this.PRICE_CLASS).text(Number((size.data('price')).toFixed(0)).toLocaleString('ru-RU') + ' руб.');
        // }

        BX.Event.EventEmitter.emit(`Mario.Card:setOffer`,  { 
            productId: this.productId,
            offer: this.selected.offer
        });

        return true;
    }
    findOffer(size) {
        let possibleOffer;

        for (let key in this.offers) {
            if (!this.offers.hasOwnProperty(key)) {
                continue;
            }

            possibleOffer = this.offers[key];

            if (String(possibleOffer.size.value) === String(size)) {
                return possibleOffer;
            }
        }

        return null;
    }
    setCheckedId() {
        let id = (this.selected.offer) ? this.selected.offer.id : null;
        let size = this.selected.size.data('value') || null;
        let remains = this.selected.offer.quantity || null;

        this.wrapper.find('.' + this.OFFER_ID_CLASS).val(id);
        this.wrapper.find('.' + this.OFFER_ID_CLASS).attr('data-value', size);
        this.wrapper.find('.' + this.OFFER_REMAINS_CLASS).val(remains);
    }
    initSelected() {
        let
            $activeSize = $('.js-product_offer-size-wrapper.active');

        if ($activeSize.length == 0){
            return false;
        }

        this.selected.size = $activeSize.find('.js-product_offer-size');
        this.setOffer();
    }
    initButtons() {
        if (!this.selected.offer) {
            return;
        }

        if (this.selected.offer.quantity == 0 || this.selected.offer.quantity == this.selected.offer.quantity_in_basket) {
            this.disableButtons();
        } else {
            this.enableButtons();
        }
    }
    disableButtons() {
        this.wrapper.find('.' + this.ADD_TO_BASKET_BUTTON_CLASS).addClass('disabled').prop('disabled', true);
        this.wrapper.find('.' + this.FAST_BUY_BUTTON_CLASS).addClass('disabled').prop('disabled', true);
    }
    enableButtons() {
        if (!this.selected.offer) {
            return;
        }

        this.wrapper.find('.' + this.ADD_TO_BASKET_BUTTON_CLASS).removeClass('disabled').removeAttr('disabled');
        this.wrapper.find('.' + this.FAST_BUY_BUTTON_CLASS).removeClass('disabled').removeAttr('disabled');
    }
    setArticle() {
        let articleBlock = this.wrapper.find('.' + this.ARTICLE_CLASS),
            defaultArticle = articleBlock.data('default'),
            colorOffer;

        if (!this.selected.color) {
            return;
        }

        colorOffer = false;

        if (!colorOffer || !colorOffer.hasOwnProperty('article') || !colorOffer.article) {
            if (defaultArticle) {
                articleBlock.text(defaultArticle);
            }

            return;
        }

        articleBlock.text(colorOffer.article);
    }
}
